<template>
  <el-dialog
    title="院校详情报告"
    :visible.sync="dialogFormVisible"
    @close="emitClose"
    :close-on-click-modal="false"
    width="1300px"
  >
    <div
      class="title"
      v-if="major"
    >({{major.value}}){{major.label}}专业考研择校分析报告</div>
    <el-form
      class="search-wrap"
      ref="searchForm"
      :inline="true"
      :model="query"
    >
      <div class="form-wrap">
        <el-form-item label-width="32px">
          <el-select
            v-model="query.report_type"
            @change="report_typeChange"
            style="width:300px;"
          >
            <el-option
              v-for="(item,index) in filters.report_types"
              :key="index"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label-width="32px"
          v-if="query.report_type==2"
        >
          <el-radio-group
            v-model="query.college_category_ids"
            @change="fetchResult(true)"
          >
            <el-radio-button
              v-for="(item,index) in filters.college_category_ids"
              :key="index"
              :label="item.value"
            >{{item.label}}</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label-width="32px"
          v-if="query.report_type==3"
        >
          <el-radio-group
            v-model="query.college_province_area"
            @change="fetchResult(true)"
          >
            <el-radio-button
              v-for="(item,index) in filters.province_area"
              :key="index"
              :label="item.value"
            >{{item.label}}</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label-width="32px"
          v-if="query.report_type==4"
        >
          <el-radio-group
            v-model="first"
            @change="firstChange"
          >
            <el-radio-button :label="1">一流高校</el-radio-button>
            <el-radio-button :label="2">一流学科</el-radio-button>
          </el-radio-group>
        </el-form-item>
      </div>

    </el-form>
    <div class="table-wrap">
      <el-table
        class="table"
        :data="results"
        border
        style="width: 100%"
        @sort-change="sortChange"
      >
        <el-table-column
          prop="id"
          label="ID"
          width="80"
          fixed="left"
          align="center"
        ></el-table-column>
        <el-table-column
          label="专业名称"
          width="200  "
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{scope.row.major_code}}{{scope.row.major_name}}
          </template>
        </el-table-column>
        <el-table-column
          label="院校信息"
          align="center"
        >
          <el-table-column
            prop="college_province_area"
            label="地区"
            width="100"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="college_province_name"
            label="所在地"
            width="100"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="college_name"
            label="院校名称"
            width="260"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <div>
                <span class="tag">{{scope.row.college_name}}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="院校类型"
            width="260"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <el-tag
                size="mini"
                v-for="(item,index) in formateCategory(scope.row.college_category_ids)"
                :key="index"
              >{{item}}</el-tag>
            </template>
          </el-table-column>
          <el-table-column
            prop="college_rank"
            label="综合排名"
            width="100"
            align="center"
            show-overflow-tooltip
            sortable
          >
            <template slot-scope="scope">
              {{scope.row.college_rank?`${scope.row.college_rank}名`:'暂无'}}
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column
          label="招生数据（全日制）"
          align="center"
        >
          <el-table-column
            prop="recruit_cmp_college_major_user_count_first"
            label="一志愿人数"
            width="120"
            align="center"
            show-overflow-tooltip
            sortable
          >
            <template slot-scope="scope">
              {{scope.row.recruit_cmp_college_major_user_count_first||0}}人
            </template>
          </el-table-column>
          <el-table-column
            prop="recruit_cmp_college_major_user_count_adjust"
            label="调剂人数"
            width="120"
            align="center"
            show-overflow-tooltip
            sortable
          >
            <template slot-scope="scope">
              {{scope.row.recruit_cmp_college_major_user_count_adjust||0}}人
            </template>
          </el-table-column>
          <el-table-column
            prop="recruit_cmp_college_major_low_score"
            label="录取最低分"
            width="120"
            align="center"
            show-overflow-tooltip
            sortable
          >
            <template slot-scope="scope">
              {{scope.row.recruit_cmp_college_major_low_score||0}}分
            </template>
          </el-table-column>
          <el-table-column
            prop="recruit_cmp_college_major_high_score"
            label="录取最高分"
            width="120"
            align="center"
            show-overflow-tooltip
            sortable
          >
            <template slot-scope="scope">
              {{scope.row.recruit_cmp_college_major_high_score||0}}分
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column
          label="综合信息"
          align="center"
        >
          <el-table-column
            label="一流高校"
            width="100"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <div v-if="scope.row.is_first_college==0">
                否
              </div>
              <div
                v-if="scope.row.is_first_college==1"
                class="is_status"
              >
                <span class="tag">是</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="一流学科"
            width="100"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <div v-if="scope.row.is_first_discipline==0">
                否
              </div>
              <div v-if="scope.row.is_first_discipline==1">
                <span class="tag">是</span>
              </div>
              <div v-if="scope.row.is_first_discipline==2">
                <span class="tag">自主确定</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="college_major_rank"
            label="专业排名"
            width="150"
            align="center"
            show-overflow-tooltip
            sortable
          >
            <template slot-scope="scope">
              {{scope.row.college_major_rank?`${scope.row.college_major_rank}名`:'暂无'}}
            </template>
          </el-table-column>
          <el-table-column
            label="推荐等级"
            width="150"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{formateLevel(scope.row.recommend_level)}}
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>
      <div class="page-footer">
        <div>
          <el-button @click="handleToExport()">下载报告<i class="el-icon-upload el-icon--right"></i></el-button>
        </div>
        <el-pagination
          background
          layout="total, prev, pager, next, sizes, jumper"
          :current-page="Number(query.pageIndex)"
          :page-sizes="[10, 20, 50, 100, 500]"
          :page-size="Number(query.pageSize)"
          :total="Number(pageTotal)"
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
        ></el-pagination>
      </div>
    </div>
    <div class="footer">
      <el-button @click="emitClose()">取消</el-button>
      <el-button
        type="primary"
        @click="submit('formRules')"
      >确定</el-button>
    </div>
  </el-dialog>
</template>

<script>


import { corelist, coreExport } from "@/api/common";

export default {
  components: {
  },
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
    id: {
      type: Number,
      default: () => {
        return null;
      },
    },
    major: {
      type: Object,
      default: () => { },
    },
  },
  data() {
    return {
      dialogFormVisible: this.isVisible,
      dataForm: {},
      detail: {},
      results: [],
      query: {
        pageIndex: 1,
        pageSize: 10,
        isPaging: 1,
        report_type: 1
      },
      pageTotal: 0,
      filters: {
        report_types: [
          { label: '本专业排名TOP30', value: 1 },
          { label: '招收本专业的985/211及双非院校', value: 2 },
          { label: '各地区招手本专业的报考院校推荐', value: 3 },
          { label: '招收本专业的一流学科及一流高校的院校推荐', value: 4 },
          { label: '招手本专业的院校综合排名TOP50', value: 5 },
          { label: '一志愿招生人数靠前的院校TOP30', value: 6 },
          { label: '一志愿录取最低分较低的院校TOP30', value: 7 },
        ],
        college_category_ids: [
          { value: 0, label: '双非' },
          { value: 1, label: '985' },
          { value: 2, label: '211' },
          { value: 3, label: '一流大学' },
          { value: 4, label: '一流学科' },
          { value: 5, label: '自主划线' }
        ],
        recommend_level: [
          { value: 0, label: '二本三本可报考' },
          { value: 1, label: '一本二本可报考' },
          { value: 2, label: '211/双一流可报考' },
          { value: 3, label: '985/211可报考' },
          { value: 4, label: '不推荐报考' },
        ],
        province_area: [
          { value: '华北地区', label: '华北地区' },
          { value: '西北地区', label: '西北地区' },
          { value: '东北地区', label: '东北地区' },
          { value: '华东地区', label: '华东地区' },
          { value: '华中地区', label: '华中地区' },
          { value: '华南地区', label: '华南地区' },
          { value: '西南地区', label: '西南地区' },
        ]
      },
      first: 0,
    };
  },
  mounted() {

  },
  watch: {
    isVisible(val) {
      this.dialogFormVisible = val;
      if (val) {
        this.fetchResult()
      }
    },
  },
  methods: {
    // 分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, "pageSize", val);
      this.fetchResult();
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, "pageIndex", val);
      this.fetchResult();
    },
    fetchResult(isReset = false) {
      if (isReset) {
        this.query.pageIndex = 1
      }
      const params = Object.assign({}, this.query, {
        is_report: 1,
        report_major_code: this.major.value,
      })
      corelist(params).then((res) => {
        this.results = res.list || [];
        this.pageTotal = res.count;
      });
    },
    emitClose() {
      this.$emit("close");
    },
    formateLevel(val) {
      if (val) {
        return this.filters.recommend_level[val].label
      } else {
        return "暂无"
      }
    },
    formateCategory(val) {
      if (val) {
        let arr = val.split(',')
        let final = arr.map(v => {
          return this.filters.college_category_ids.find(t => {
            return t.value == v
          }).label
        })
        return final
      } else {
        return []
      }
    },
    report_typeChange(e) {
      this.query.college_category_ids = null
      this.query.college_province_area = null
      this.query.is_first_college = null
      if (e == 2) {
        this.query.college_category_ids = 0
      } else if (e == 3) {
        this.query.college_province_area = '华北地区'
      } else if (e == 4) {
        this.first = 1
        this.query.is_first_college = 1
      }
      this.fetchResult(true)
    },
    firstChange(e) {
      if (e == 1) {
        this.query.is_first_college = 1
      } else if (e == 2) {
        this.query.is_first_discipline = 1
      }
      this.fetchResult(true)
    },
    sortChange(col) {
      // ascending升序
      // descending降序
      delete this.query.order_college_rank_asc
      delete this.query.order_college_major_rank_asc
      delete this.query.order_user_count_first_asc
      delete this.query.order_user_count_adjust_asc
      delete this.query.order_low_socre_asc
      delete this.query.order_high_socre_asc
      if (col.prop == "college_rank") {//院校排名排序是否升序
        if (col.order == "ascending") {
          this.query.order_college_rank_asc = 1
        } else if (col.order == "descending") {
          this.query.order_college_rank_asc = 0
        }
      } else if (col.prop == "college_major_rank") {//院校专业排名排序是否升序
        if (col.order == "ascending") {
          this.query.order_college_major_rank_asc = 1
        } else if (col.order == "descending") {
          this.query.order_college_major_rank_asc = 0
        }
      } else if (col.prop == "recruit_cmp_college_major_user_count_first") {//一志愿录取人数排序是否升序
        if (col.order == "ascending") {
          this.query.order_user_count_first_asc = 1
        } else if (col.order == "descending") {
          this.query.order_user_count_first_asc = 0
        }
      } else if (col.prop == "recruit_cmp_college_major_user_count_adjust") {//调剂录取人数排序是否升序
        if (col.order == "ascending") {
          this.query.order_user_count_adjust_asc = 1
        } else if (col.order == "descending") {
          this.query.order_user_count_adjust_asc = 0
        }
      } else if (col.prop == "recruit_cmp_college_major_low_score") {//一志愿录取最低分排序是否升序
        if (col.order == "ascending") {
          this.query.order_low_socre_asc = 1
        } else if (col.order == "descending") {
          this.query.order_low_socre_asc = 0
        }
      } else if (col.prop == "recruit_cmp_college_major_high_score") {//一志愿录取最高分排序是否升序
        if (col.order == "ascending") {
          this.query.order_high_socre_asc = 1
        } else if (col.order == "descending") {
          this.query.order_high_socre_asc = 0
        }
      }
      this.fetchResult()
    },
    handleToExport() {
      const params = Object.assign({}, this.query, {
        is_report: 1,
        report_major_code: this.major.value,
      })
      coreExport(params).then((res) => {
        if (res) {
          this.getBlob(res.url, res.name)
        }
      });
    },
    getBlob(imgurl, filename = '文件') {
      var ajax = new XMLHttpRequest();
      ajax.open("GET", imgurl, true);
      ajax.responseType = 'blob';
      ajax.onload = e => {
        let res = e.target.response
        let blob = new Blob([res], { type: res.type }) // 这里的res为后端返回的流数据
        if (window.navigator.msSaveOrOpenBlob) { //兼容IE10
          navigator.msSaveBlob(blob, filename)
        } else {
          const href = URL.createObjectURL(blob) //创建新的URL表⽰指定的blob对象
          const a = document.createElement('a') //创建a标签
          a.style.display = 'none'
          a.href = href // 指定下载链接
          a.download = filename //指定下载⽂件名
          a.click() //触发下载
          URL.revokeObjectURL(a.href) //释放URL对象
        }
      }
      ajax.send()
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  padding: 16px;
  .title {
    text-align: center;
    font-size: 32px;
    font-family: PingFang SC-Semibold, PingFang SC;
    font-weight: 600;
    color: #303133;
    margin-bottom: 16px;
  }
  .table-wrap {
    margin-top: 16px;
  }
}
.footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 16px;
}
.el-tag {
  & + .el-tag {
    margin-left: 8px;
  }
}
.tag {
  padding: 3px 6px;
  background: rgba(64, 158, 255, 0.102);
  border-radius: 4px 4px 4px 4px;
  opacity: 1;
}
.form-wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.page-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 16px;
}
</style>